/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-return */
import React, { useState, useEffect, useRef } from "react";
import { getBaseUrl } from "../../constants";
import Axios from "../../api/Axios";
import { postHistory } from "../../api/History";
import { getItem } from "../../utils/nauth";
import { Box, Button, CircularProgress, Container } from "@mui/material";
import Dlg from "../../components/Dlg";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useStore } from "../../store";
import { ICategories } from "../Templates/ITemplateDetail";
import moment from "moment";

interface IExtraDescription {
  language: string;
  languageName: string;
  description: string;
  hashTags?: string[] | null;
}

const ListModerationBtn = ({ template }: any) => {
  const {
    ModerationStore: {
      gacha,
      setGacha,
      setRows,
      isReviewer,
      setIsReviewer,
      gridOption: { loading },
      setGridOption,
      // isBlind,
      // setIsBlind,
    },
  } = useStore();

  const config = {
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
      "Content-type": "application/json",
    },
  };

  const [isLoading, setIsLoading] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [reviewerName, setReviewerName] = useState("");
  const [openPublishDlg, setPublishOpenDlg] = useState(false);
  const [openRejectDlg, setRejectOpenDlg] = useState(false);
  const [openBlindDlg, setBlindOpenDlg] = useState(false);
  const [warningPublishDlg, setWarningPublishOpenDlg] = useState(false);

  const [gReviewer, setReviewer] = useState(isReviewer);

  const [isGacha, setIsGacha] = useState(template.isGacha);
  const [categoriesArr, setCategoriesArr] = useState<ICategories[]>(
    template.categories || []
  );
  const [category, setCategory] = useState<string[]>(template.category || []);

  const baseUrl = `${getBaseUrl()}/v1/templates`;
  const userEmail = getItem("email") || getItem("name") || "No name";
  const userRole = getItem("role");

  const [regionCode, setRegionCode] = useState<string[]>(
    template.metaCountryCode.length >= 249
      ? ["allcountrycode"]
      : template.metaCountryCode
  );

  const [forbidden, setForbidden] = useState(template.forbiddenWords);
  const hentai = template.nsfw && Number(template.nsfw.hentai) * 100;
  const porn = template.nsfw && Number(template.nsfw.porn) * 100;
  const sexy = template.nsfw && Number(template.nsfw.sexy) * 100;

  const [isBlind, setIsBlind] = useState<boolean>(template.isBlind);

  // const blindRef = useRef<boolean>(isBlind);

  const nsfwWarning = (hentai: number, porn: number, sexy: number) => {
    if (hentai >= 80) return true;
    else if (porn >= 90) return true;
    else if (sexy >= 50) return true;
    else return false;
  };

  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };

  const isAdminRole = () => {
    return userRole === "admin";
  };

  const setName = () => {
    let name;
    if (localStorage.getItem("email")) {
      name = localStorage.getItem("email")?.split("@")[0];
    } else {
      name = localStorage.getItem("name");
    }
    setReviewerName(name ? name : "");
  };

  const getReviwer = async () => {
    const templateUrl = `${baseUrl}/${template.templateId}`;

    let reviewer;
    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          reviewer = data.reviewer;
          setReviewerName(reviewer);
        })
        .catch((err) => {
          console.log("getReviewr Err", err);
        });
    } catch (err) {
      console.log("getReviewer", err);
    }
    return reviewer;
  };
  const handleReviewerAssignBtnYes = async () => {
    setGridOption({ loading: true });
    if (!isUserRole()) {
      alert("You cannot register as a reviewer with that right.");
      return;
    }
    const targetElement = document.querySelector(
      `[data-id="${template.templateId}"]`
    );

    const reviewer = await getReviwer();
    if (reviewer !== "" && reviewer !== userEmail) {
      const reviewerFullName = reviewer || "";
      targetElement?.classList.add("is-reviewer");
      const rSplit = reviewerFullName.split("@")[0];
      setReviewerName(rSplit);
      alert(
        "Someone has changed the template state\n(The review is already in progress.)"
      );

      setIsGacha(false);

      return;
    }

    const raUserName = template.author.name;
    const raUserId = template.author.sub;
    try {
      await Axios("PATCH", `${baseUrl}/${template.templateId}/reviewer`)
        .then(async () => {
          const data = {
            action: "Start Review",
            templadteId: template.templateId,
            userName: raUserName,
            userId: raUserId,
            status: "In Review -> Start Review",
          };
          await postHistory(userEmail, data).catch((err) => {
            console.log("start review err", err);
          });
          targetElement?.classList.add("is-reviewer");
          setName();
          // setReviewer(true);
          setIsReviewer(true);
        })
        .catch((err) => {
          console.log("Start Review err", err);
        });
    } catch (error) {
      console.log("Start Review err", error);
    } finally {
      setGridOption({ loading: false });
    }
  };

  const toggleGacha = async () => {
    const reviewer = await getReviwer();
    if (reviewer === "" || reviewer !== userEmail) {
      alert(
        "The reviewer is not registered or is different from the registered reviewer."
      );
      setRows();
      return;
    }

    if (!isGacha) {
      categoriesArr.includes({ id: "646fa1cadb9fff789a946348" })
        ? setCategoriesArr([...categoriesArr])
        : setCategoriesArr([
            ...categoriesArr,
            { id: "646fa1cadb9fff789a946348" },
          ]);

      category.includes("Gacha")
        ? setCategory([...category])
        : setCategory([...category, "Gacha"]);

      setIsGacha(!gacha);
    } else {
      setCategoriesArr(
        categoriesArr.filter((e: any) => e.id !== "646fa1cadb9fff789a946348")
      );

      setCategory(category.filter((e: any) => e !== "Gacha"));
      setIsGacha(!gacha);
    }
    const categoryLang = template.categories;
    if (categoryLang.toString() !== categoriesArr.toString()) setIsGacha(false);
    else setIsGacha(true);
  };

  const getTemplated = async (url: string, id: any, sp?: any) => {
    const templateUrl = `${baseUrl}/${id}`;
    let temp: any = null;
    let item = sp || {
      action: "Get Templated",
      templadteId: id,
    };

    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          if (data.response) {
            item = {
              ...item,
              status: "Error",
              error:
                "getTemplated API call failed(code: " +
                data.response.status +
                ")",
            };
            setTimeout(
              () =>
                postHistory(userEmail, item).catch((err) => {
                  console.log("err", err);
                }),
              500
            );
            alert("This template does not exist.");
          } else {
            temp = data;
          }
        })
        .catch((err) => {
          item = {
            ...item,
            status: "Error",
            error: "getTemplated (" + err.response + ")",
          };

          console.log("item", err);
          setTimeout(
            () =>
              postHistory(userEmail, item)
                .then(() => {
                  alert("This template does not exist.");
                })
                .catch((err) => {
                  console.log("err", err);
                }),
            500
          );
        });

      return temp;
    } catch (error) {
      console.log("getTemplated Err", error);
    }
  };

  const handleReject = async () => {
    if (template.reviewStatus === "Rejected") {
      alert("The template you selected is already Rejected.");
      return false;
    }

    const reviewer = await getReviwer();
    if (reviewer === "" || reviewer !== userEmail) {
      alert(
        "The reviewer is not registered or is different from the registered reviewer."
      );
      setRows();
      return;
    }

    setRejectOpenDlg(true);
  };

  const handlePublish = async () => {
    if (template.reviewStatus === "Published") {
      alert("The template you selected is already Published.");
      return false;
    }
    const reviewer = await getReviwer();
    if (reviewer === "" || reviewer !== userEmail) {
      alert(
        "The reviewer is not registered or is different from the registered reviewer."
      );
      setRows();
      return;
    }

    if (forbidden || nsfwWarning(hentai, porn, sexy))
      setWarningPublishOpenDlg(true);
    else setPublishOpenDlg(true);
  };

  const handlePublishBtnYes = async () => {
    setGridOption({ loading: true });

    try {
      await moderationSubmit();
    } catch (error) {
      console.log("handlePublish Reviewer Err");
    }

    if (isAdminRole() || (await getReviwer()) === userEmail) {
      setPublishOpenDlg(false);
      setWarningPublishOpenDlg(false);
      setOpenProgress(true);

      const pId = template.templateId;
      const pUserName = template.author.name;
      const pUserId = template.author.sub;
      const pTemplateArr = [];
      let data: any;

      pTemplateArr.push(pId);

      try {
        let pData = {
          templatesIds: pTemplateArr,
        };
        const startTime = moment().format("YYYY-MM-DD HH:mm:ss");
        await Axios("PATCH", `${baseUrl}/publish`, pData, config)
          .then(async (res) => {
            if (!res) {
              const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
              data = {
                action: "Publish",
                templadteId: pId,
                userName: pUserName,
                userId: pUserId,
                status: template.reviewStatus + " -> Published",
                // startTime: startTime,
                // endTime: endTime,
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("err", err);
              });
            } else {
              data = {
                action: "Publish",
                templadteId: pId,
                userName: pUserName,
                userId: pUserId,
                status: "Error",
                error:
                  "Publish API call failed(code: " + res.response.status + ")",
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("err", err);
              });
              if (res.status === 403) {
                alert(
                  `The registered reviewer and user are not the same. ${res.status`Err`}`
                );
                return;
              } else {
                alert(
                  "An error occurred while rejecting the template. (Publish Err)"
                );
                return;
              }
            }
          })
          .catch((err) => {
            console.log("publishErr", err);
          });
      } catch (err) {
        console.log("error", err);
      } finally {
        data = {
          action: "Publish",
          templadteId: pId,
          userName: pUserName,
          userId: pUserId,
        };

        setGridOption({ loading: false });
        setRows();
      }
    } else {
      setPublishOpenDlg(false);
      setWarningPublishOpenDlg(false);
      alert("You are not a registered reviewer.");

      setRows();

      return;
    }
  };

  const handleRejectBtnYes = async () => {
    if (isAdminRole() || (await getReviwer()) === userEmail) {
      setRejectOpenDlg(false);
      setOpenProgress(true);

      const rId = template.templateId;
      const rUserName = template.author.name;
      const rUserId = template.author.sub;
      const rTemplateArr = [];
      let data: any;

      rTemplateArr.push(rId);

      try {
        const rData = {
          templatesIds: rTemplateArr,
          rejected: {
            reason: "screening",
            fails: ["video", "image", "file", "description"],
          },
        };

        await Axios("PATCH", `${baseUrl}/reject`, rData, config)
          .then(async (res) => {
            if (!res) {
              data = {
                action: "Reject",
                templadteId: rId,
                userName: rUserName,
                userId: rUserId,
                status: template.reviewStatus + " -> Rejected",
                rejected: {
                  reason: "screening",
                  fails: ["video", "image", "file", "description"],
                },
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("HistoryErr", err);
              });
            } else {
              data = {
                action: "Reject",
                templadteId: rId,
                userName: rUserName,
                userId: rUserId,
                status: "Error",
                error:
                  "Reject API call failed (code: " + res.response.status + ")",
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("HistoryErr", err);
              });
              if (res.status === 403) {
                alert(
                  `The registered reviewer and user are not the same. ${res.status`Err`}`
                );
                return;
              } else {
                alert(
                  "An error occurred while rejecting the template. (Reject Err)"
                );
                return;
              }
            }
          })
          .catch((err) => {
            console.log("rejectErr", err);
          });
      } catch (err) {
        console.log(err);
      } finally {
        data = {
          action: "Reject",
          templadteId: rId,
          userName: rUserName,
          userId: rUserId,
        };
        setOpenProgress(false);
        setRows();
      }
    } else {
      setRejectOpenDlg(false);
      alert("You are not a registered reviewer.");

      setRows();
      return;
    }
  };

  const handleBlind = async (isBlind: boolean) => {
    const reviewer = await getReviwer();
    if (reviewer === "" || reviewer !== userEmail) {
      alert(
        "The reviewer is not registered or is different from the registered reviewer."
      );
      setRows();
      return;
    }
    setIsBlind(isBlind);
    // blindRef.current = isBlind;
    setBlindOpenDlg(true);
  };

  const handleBlindBtnYse = async () => {
    if (isAdminRole() || (await getReviwer()) === userEmail) {
      setBlindOpenDlg(false);
      setOpenProgress(true);

      const action = isBlind ? "Blind" : "Unblind";

      const templatesID = template.templateId;
      const bUserName = template.author.name;
      const bUserId = template.author.sub;

      let item: any;
      const jData = {
        isBlind: isBlind,
      };

      try {
        await Axios("PATCH", `${baseUrl}/${templatesID}/blind`, jData, config)
          .then(async (res) => {
            if (!res) {
              item = {
                action: action,
                templadteId: templatesID,
                userName: bUserName,
                userId: bUserId,
                status: template.reviewStatus,
              };
              await postHistory(userEmail, item).catch((err) => {
                console.log("HistoryErr", err);
              });
            } else {
              item = {
                action: action,
                templadteId: templatesID,
                userName: bUserName,
                userId: bUserId,
                status: "Error",
                error:
                  "Reject API call failed (code: " + res.response.status + ")",
              };
              await postHistory(userEmail, item).catch((err) => {
                console.log("HistoryErr", err);
              });
              alert("An error occurred while changing the state. (Blind Err)");
              return;
            }
          })
          .catch((err) => {
            console.log("rejectErr", err);
          });
      } catch (err) {
        console.log(err);
      } finally {
        item = {
          action: "Blind",
          templadteId: templatesID,
          userName: bUserName,
          userId: bUserId,
        };
        setRows();
        setOpenProgress(false);
      }
    } else {
      setBlindOpenDlg(false);
      alert("You are not a registered reviewer.");
      return;
    }
  };

  const removeHashTagsFromObject = (
    data: IExtraDescription
  ): Omit<IExtraDescription, "hashTags"> => {
    const { hashTags, ...rest } = data;
    return rest;
  };

  const moderationSubmit = async () => {
    const templateData: any = await getTemplated(baseUrl, template.templateId);

    let dataObj: any;

    const extraDescription: Omit<IExtraDescription, "hashTags"> =
      removeHashTagsFromObject(templateData.extraDescription);

    const templatesIds = template.templateId;
    const scores = templateData.scores;

    const metaLanguageCode = templateData.metaLanguageCode;
    const metaCountryCode = templateData.metaCountryCode;

    const categories = categoriesArr || templateData.categories;

    const data = {
      scores,
      categories,
      metaLanguageCode,
      metaCountryCode,
      extraDescription,
    };

    try {
      await Axios("PATCH", `${baseUrl}/${templatesIds}`, data, config).then(
        async (res) => {
          const tUserName = template.author.name;
          const tUserId = template.author.sub;

          if (!res) {
            const rcArr: any[] = metaCountryCode.map((item: any) => {
              return item;
            });
            dataObj = {
              action: "Moderation",
              templadteId: template.templateId,
              userName: tUserName,
              userId: tUserId,
              scores: {
                mixability:
                  templateData.scores.mixability +
                  " -> " +
                  templateData.scores.mixability,
                reference:
                  templateData.scores.reference +
                  " -> " +
                  templateData.scores.reference,
                asset:
                  templateData.scores.asset +
                  " -> " +
                  templateData.scores.asset,
                entertainment:
                  templateData.scores.entertainment +
                  " -> " +
                  templateData.scores.entertainment,
              },
              description: templateData.extraDescription.description
                ? templateData.extraDescription.description +
                  " -> " +
                  templateData.extraDescription.description
                : "",
              category: {
                category:
                  templateData.category.join(", ") +
                  " -> " +
                  category?.join(", "),
              },
              metaLanguageCode:
                templateData.metaLanguageCode +
                " -> " +
                templateData.metaLanguageCode,
              metaCountryCode:
                templateData.metaCountryCode.length >= 249
                  ? "allcountrycode -> " + rcArr.join(", ")
                  : regionCode.length >= 249
                  ? templateData.metaCountryCode + " -> allcountrycode"
                  : templateData.metaCountryCode + " -> " + rcArr.join(", "),
            };

            await postHistory(userEmail, dataObj).catch((err) => {
              console.log("HistoryErr", err);
            });
          } else {
            dataObj = {
              action: "Moderation",
              templadteId: template.templateId,
              userName: tUserName,
              userId: tUserId,
              status: "Error",
              error: "Moderation (code: " + res.response.status + ")",
            };

            await postHistory(userEmail, dataObj).catch((err) => {
              console.log("HistoryErr", err);
            });

            alert(
              "An error occurred while changing the state. (Moderation Err)"
            );
            return false;
          }
        }
      );
    } catch (error) {
      console.log("moerationErr", error);
    }
  };

  useEffect(() => {
    setName();
    setReviewer(isReviewer);
  }, [isReviewer]);

  if (isLoading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <>
      <Box>
        {isGacha ? (
          <>
            <Box>
              <Button
                style={{
                  cursor: "pointer",
                  fontSize: "13px",
                  textAlign: "center",
                  paddingBottom: "3px",
                  color: "rgba(0, 0, 0, 0.87)",
                }}
                onClick={toggleGacha}
              >
                Gacha&nbsp;
                <CheckIcon
                  fontSize="small"
                  sx={{ color: "#07A499", fontSize: "14px", pt: "5px" }}
                  onClick={toggleGacha}
                />
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box>
              <Button
                size="small"
                style={{
                  cursor: "pointer",
                  opacity: "0.7",
                  fontSize: "13px",
                  textAlign: "center",
                  paddingBottom: "3px",
                  color: "rgba(0, 0, 0, 0.87)",
                }}
                onClick={toggleGacha}
              >
                Gacha&nbsp;
                <CloseIcon
                  fontSize="small"
                  sx={{
                    color: "#B3261E",
                    fontSize: "14px",
                    pt: "5px",
                  }}
                />
              </Button>
            </Box>
          </>
        )}

        <Box style={{ textAlign: "center" }}>
          <Button
            onClick={() => {
              if (template.reviewStatus === "Rejected" && !isAdminRole()) {
                alert(
                  "You do not have permission. \nPlease contact the administrator."
                );
              } else {
                handlePublish();
              }
            }}
            size="small"
            variant="outlined"
            sx={{
              height: "25px",
              mb: "3px",
            }}
            style={{
              color: "#6750a4",
              borderColor: "#6750a4",
              fontSize: "12px",
              minWidth: "85px",
              padding: "0",
              textAlign: "center",
            }}
          >
            Publish
          </Button>
        </Box>
        <Box style={{ textAlign: "center" }}>
          <Button
            onClick={handleReject}
            size="small"
            variant="outlined"
            sx={{
              height: "25px",
              mb: "3px",
            }}
            style={{
              color: "#6750a4",
              borderColor: "#6750a4",
              fontSize: "12px",
              minWidth: "85px",
              padding: "0",
              textAlign: "center",
            }}
          >
            Reject
          </Button>
        </Box>
        {template.reviewStatus !== "Rejected" && (
          <>
            <Box style={{ textAlign: "center" }}>
              {isBlind ? (
                <Button
                  onClick={() => {
                    handleBlind(false);
                  }}
                  size="small"
                  variant="outlined"
                  sx={{
                    height: "25px",
                  }}
                  style={{
                    color: "#6750a4",
                    borderColor: "#6750a4",
                    fontSize: "12px",
                    minWidth: "85px",
                    padding: "0",
                    textAlign: "center",
                  }}
                >
                  Unblind
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    handleBlind(true);
                  }}
                  size="small"
                  variant="outlined"
                  sx={{
                    height: "25px",
                  }}
                  style={{
                    color: "#6750a4",
                    borderColor: "#6750a4",
                    fontSize: "12px",
                    minWidth: "85px",
                    padding: "0",
                    textAlign: "center",
                  }}
                >
                  Blind
                </Button>
              )}
            </Box>
          </>
        )}
      </Box>

      <Dlg
        open={openPublishDlg}
        contentText={"Are you sure you want to proceed with publishing?"}
        handleNo={() => {
          setPublishOpenDlg(false);
        }}
        handlePublishYes={handlePublishBtnYes}
        reviewStatus={template.reviewStatus}
      />

      <Dlg
        open={warningPublishDlg}
        contentText={
          "Warning: The content may contain forbidden words or inappropriate content such as 'Hentai,' 'Porn,' or 'Sexy' elements. Are you sure you want to proceed with publishing?"
        }
        handleNo={() => {
          setWarningPublishOpenDlg(false);
        }}
        handlePublishYes={handlePublishBtnYes}
        reviewStatus={template.reviewStatus}
        warning={true}
      />

      <Dlg
        open={openRejectDlg}
        contentText={"Are you sure you want to reject selected projects?"}
        handleNo={() => {
          setRejectOpenDlg(false);
        }}
        handleRejectYes={handleRejectBtnYes}
        reviewStatus={template.reviewStatus}
      />
      <Dlg
        open={openBlindDlg}
        contentText={"Are you sure you want to proceed with blind?"}
        handleNo={() => {
          setBlindOpenDlg(false);
          setIsBlind(!isBlind);
        }}
        handleBlindYse={handleBlindBtnYse}
        reviewStatus={template.reviewStatus}
      />
    </>
  );
};

export default ListModerationBtn;
